export default function reducer(
    state = {
        isAuth: false,
        isPublic: false,
        info: {
            created: null,
            id: null,
            principalType: null,
            role: null,
            ttl: null,
            userId: null,
            profile: {
                email: null
            }
        },
        status: 'logoutFulfilled',
        error: null,
        message: "",
        code: null,
        showAlert: false,
    },
    action
) {
    switch (action.type) {
        case "USER_LOGIN_PENDING":
            state = {
                ...state,
                status: 'loginPending',
            };
            break;
        case "USER_LOGIN_FULFILLED":
            var nstate = {
                ...state,
                info: { ...action.payload },
                status: 'loginFulfilled',
                error: null,
                code: null,
                isAuth: true,
                showAlert: false,
            };
            localStorage.setItem("guardexpert_logon", JSON.stringify(nstate));
            //console.log("LocalStorage >", ",guardexpert_logon :\n" + localStorage.getItem("guardexpert_logon"));
            state = nstate;
            break;
        case "USER_LOGIN_REJECTED":
            localStorage.removeItem("guardexpert_logon");
            state = {
                ...state,
                status: 'loginRejected',
                error: action.payload.error,
                message: action.payload.message,
                code: action.payload.code,
                showAlert: true,
            };
            break;
        case "USER_LOGOUT_PENDING":
            state = {
                ...state,
                status: 'logoutPending'
            };
            break;
        case "USER_LOGOUT_FULFILLED":
            localStorage.removeItem("guardexpert_logon");
            state = {
                ...state,
                info: {
                    created: null,
                    id: null,
                    principalType: null,
                    role: null,
                    ttl: null,
                    userId: null,
                    profile: {
                        email: null
                    }
                },
                status: 'logoutFulfilled',
                error: null,
                code: null,
                isAuth: false,
                isPublic: false,
                showAlert: false,
            };
            break;
        case "USER_LOGOUT_REJECTED":
            localStorage.removeItem("guardexpert_logon");
            state = {
                ...state,
                info: {
                    created: null,
                    id: null,
                    principalType: null,
                    role: null,
                    ttl: null,
                    userId: null,
                    profile: {
                        email: null
                    }
                },
                status: 'logoutFulfilled',
                error: null,
                code: null,
                isAuth: false,
                showAlert: false,
            };
            break;
        case "USER_LOGON_RESTORE":
            state = action.payload
            break;
        case "USER_LOGON_DISMISS":
            state = {
                ...state,
                showAlert: false,
            };
            break;
        default:
            return state;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/_auth.js